import React, {useState, useEffect} from "react";
import { Link,Redirect } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// image
import logo from "../../images/logo_web_white.png";
import OtpInput from 'react-otp-input';
import { SelectionState } from "draft-js";
const prefix = process.env.REACT_APP_API_URL

const Login = ({ history }) => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpFlag, setOtpFlag] = useState(false);
  const [messageId, setMessageId] = useState("");
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState("");
  const [login, setLogin] = useState();
  const [loginState, setLoginState] = useState(false);

  useEffect(() => {
    setLoginState(true)
  }, []);

  if (localStorage.getItem("login")) {
    const { from } = {
      from: {
        pathname: "/",
      },
    };
    return <Redirect to={from} />;
  }

  const verifyOtpAndLogin = () => {

   
   
    if(!otp || otp.length !== 6){
      toast.error("Invalid otp.", {
        position: "top-right",
      });
    } else {
      setLoading(true)
      let requestObj = {
        otp: otp,
        signature: process.env.REACT_APP_TWO_FACTOR_SIGNATURE,
        mfa_request_id : messageId,
        type: "support",
        user_id : userId,
        email : email
      };
      // return dispatch => {
      axios
      .post(prefix + "/api/verify-mfa", requestObj)
      .then((res) => {
        if(res.data.status && res.data.status == "error"){
          toast.error(res.data.message, {
            position: "top-right",
          });
          // setOtpFlag(false)
          setOtp("")
          setLoading(false)

        } else {
          setLoading(false) 
          // setOtpFlag(false)
          localStorage.setItem("bgToken", res.data.accessToken)
          localStorage.setItem("userType", res.data.user_type ? res.data.user_type : "")
          localStorage.setItem("profilepic", res.data.profile_pic ? res.data.profile_pic : "")
          localStorage.setItem("userName", res.data.userName ? res.data.UserNAme : "")
          localStorage.setItem("ticketProfileName", res.data.profileName ? res.data.profileName : "")
          // return dispatch => {
          // dispatch({
          //   type: 'LOGIN'
          // })
          localStorage.setItem("login", true)
          setLogin({})
          history.push("/ticket-list");
          setLogin({})
        // }
        }
        
      })
      .catch((err) => {
        setLoading(false)
        let message = "Something went wrong"
        if(err.response && err.response.data && err.response.data.message){
          message = err.response.data.message
        }
        toast.error(message, {
          position: "top-right",
        });
        console.log(err)
      })
    // }
    }
  }

  const submitHandler = (e) => {
    e.preventDefault();
    let errFlag = false
    if(email == ""){
      errFlag = true;
      toast.error("Email is required.", {
        position: "top-right",
      });
    } else if(password == ""){
      errFlag = true;
      toast.error("Password is required.", {
        position: "top-right",
      });
    }

    if(!errFlag){
      setLoading(true)
      let requestObj = {
        email: email,
        password: password,
      };

      axios
      .post(prefix + "/api/login_without_2fa", requestObj)
      .then((res) => {
        setLoading(false)
        localStorage.setItem("bgToken", res.data.accessToken)
          localStorage.setItem("userType", res.data.user_type ? res.data.user_type : "")
          localStorage.setItem("profilepic", res.data.profile_pic ? res.data.profile_pic : "")
          localStorage.setItem("ticketProfileName", res.data.profileName ? res.data.profileName : "")
          localStorage.setItem("userId", res.data.userId ? res.data.userId : "")
          localStorage.setItem("login", true)
          setLogin({})
          history.push("/ticket-list");
          setLogin({})
          // return dispatch => {
        // setOtpFlag(true)
        // setMessageId(res.data.mfaData.id)
        // setUserId(res.data.userId)
      })
      .catch((err) => {
        setLoading(false)
        let message = "Something went wrong"
        if(err.response && err.response.data && err.response.data.message){
          message = err.response.data.message
        }
        toast.error(message, {
          position: "top-right",
        });
        console.log(err)
      })
  } 
}

  return (
    <div style={{ minHeight: window.screen.height - 60 }}>
      <div style={{display : 'none'}}>{loginState}</div>
    <div className="authincation h-100 p-meddle login-bg" >
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      {/* <Link to="/"> */}
                        <img src={logo} alt="" style={{maxWidth : "230px"}}/>
                      {/* </Link> */}
                    </div>
                    <h4 className="text-center mb-4 text-white">
                      Sign in your account
                    </h4>
                    { !otpFlag ?
                    <form onSubmit={(e) => submitHandler(e)}>
                      <div className="form-group">
                        <label className="mb-1 text-white">
                          <strong>Email</strong>
                        </label>
                        <input
                          autoFocus
                          type="email"
                          className="form-control"
                          // defaultValue="hello@example.com"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="mb-1 text-white">
                          <strong>Password</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          // defaultValue="Password"
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                      {/* <div className="form-row d-flex justify-content-between mt-4 mb-2">
                        <div className="form-group">
                          <div className="custom-control custom-checkbox ml-1 text-white">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="basic_checkbox_1"
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="basic_checkbox_1"
                            >
                              Remember my preference
                            </label>
                          </div>
                        </div>
                        <div className="form-group">
                          <Link
                            className="text-white"
                            to="page-forgot-password"
                          >
                            Forgot Password?
                          </Link>
                        </div>
                      </div> */}
                      <div className="text-center">
                        <button
                        style={{marginBottom : "1rem"}}
                          type="submit"
                          className="btn bg-white text-primary btn-block"
                          disabled={loading}
                        >
                          Sign Me In
                        </button>
                        <span className="text-center" style={{color : "white"}}>
                        Already a Provider? Use your Admin Credentials here.
                        </span>
                      </div>
                    </form>
                    :
                    <div>
                   <OtpInput
                   containerStyle={{alignItems : "center", justifyContent : "center"}}
                    value={otp}
                    onChange={(o) => setOtp(o)}
                    numInputs={6}
                    separator={<span>-</span>}
                    inputStyle= {{width : "2rem", height : "2rem"}}
                    
                  />
                  <div className="text-center" style={{paddingTop : "20px"}}>
                        <button
                          type="button"
                          className="btn bg-white text-primary btn-block"
                          onClick={() => verifyOtpAndLogin()}
                          disabled={loading}
                        >
                          Verify And Login
                        </button>
                      </div></div>}
                    {/* <div className="new-account mt-3">
                      <p className="text-white">
                        Don't have an account?{" "}
                        <Link className="text-white" to="./page-register">
                          Sign up
                        </Link>
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
    </div>
  );
};

export default Login;
